import { render, staticRenderFns } from "./myPromotion.vue?vue&type=template&id=2ad6970b&scoped=true"
import script from "./myPromotion.vue?vue&type=script&lang=js"
export * from "./myPromotion.vue?vue&type=script&lang=js"
import style0 from "./myPromotion.vue?vue&type=style&index=0&id=2ad6970b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6970b",
  null
  
)

export default component.exports